import { StoreModelType, TableResourceType } from '@smx-ui-model/types';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useRelayEnvironment } from 'react-relay';

import { ButtonCloseAllInspector } from './button-close-all-inspector';
import { WIDTH_INSPECTOR } from './consts';
import Inspector from './inspector';
import InspectorProvider from './inspector-provider';
import { InspectorReduxState } from './store/inspector-redux-state';

interface InspectorWrapperProps {
    filterProject?: string[];
}

export const InspectorWrapper: React.FC<InspectorWrapperProps> = ({ filterProject }) => {
    const environment = useRelayEnvironment();
    const currentEntityList = useSelector<InspectorReduxState, TableResourceType[]>(
        (state) => state.inspector.currentEntityList,
    );
    const storeConnectionId = useSelector<InspectorReduxState, { [key in keyof StoreModelType]: string } | undefined>(
        (state) => state.model.storeConnectionId,
    );
    const nameNewEntity = useSelector<InspectorReduxState, keyof StoreModelType | undefined>(
        (state) => state.inspector.nameNewEntity,
    );
    const parentNode = useSelector<InspectorReduxState, any | undefined>((state) => state.inspector.parentNode);
    const parentData = useSelector<InspectorReduxState, { [key: string]: any } | undefined>(
        (state) => state.inspector.parentData,
    );
    const parentModelName = useSelector<InspectorReduxState, string | undefined>(
        (state) => state.inspector.parentModelName,
    );

    const offset = WIDTH_INSPECTOR * (currentEntityList.length + (nameNewEntity ? 1 : 0));

    return (
        <>
            {nameNewEntity && (
                <InspectorProvider
                    connectionId={storeConnectionId?.[nameNewEntity]}
                    isOpen={true}
                    parentNode={parentNode}
                    parentData={parentData}
                    parentModelName={parentModelName as any}
                    filterProject={filterProject}
                >
                    <Inspector
                        key={nameNewEntity}
                        modelName={nameNewEntity}
                        offsetRight={WIDTH_INSPECTOR * currentEntityList.length}
                    />
                </InspectorProvider>
            )}
            {currentEntityList.map((entity, index) => {
                const dataFromStore = environment?.getStore().getSource().get(entity.key);

                const nameEntity = ((dataFromStore as any).__typename.charAt(0).toLowerCase() +
                    (dataFromStore as any).__typename.slice(1)) as keyof StoreModelType;

                return (
                    <InspectorProvider
                        key={entity?.key}
                        connectionId={storeConnectionId?.[nameEntity]}
                        currentId={entity.key}
                        isOpen={true}
                        filterProject={filterProject}
                    >
                        <Inspector
                            modelName={nameEntity}
                            entity={entity}
                            offsetRight={WIDTH_INSPECTOR * (index + (nameNewEntity ? 1 : 0))}
                        />
                    </InspectorProvider>
                );
            })}

            {offset > WIDTH_INSPECTOR && <ButtonCloseAllInspector offsetRight={offset} />}
        </>
    );
};
